
import Producao from "@/modules/Restaurante/pages/Producao/Index.vue";

export default {
  name: "app-restaurante-bar",
  components: {
    Producao,
  },
};
